import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(cents: number): string {
  return `£${(cents / 100).toFixed(2)}`;
}

export function centsFromPounds(pounds: number): number {
  return Math.round(pounds * 100);
}
